import { Flex, IconButton } from '@chakra-ui/react';
import { memo, useCallback } from 'react';
import { LuPencil, LuTrash2 } from 'react-icons/lu';

interface EditDeleteActionsProps {
  id: string;
  onEdit: (id: string) => void;
  onDelete?: (id: string) => void;
}

const EditDeleteActions = memo(({ id, onEdit, onDelete }: EditDeleteActionsProps) => {
  const onClickEdit = useCallback(() => {
    onEdit(id);
  }, [onEdit, id]);

  const onClickDelete = useCallback(() => {
    if (onDelete != null) {
      onDelete(id);
    }
  }, [onDelete, id]);

  return (
    <Flex gap={1}>
      <IconButton aria-label="Edit" size="2xs" variant="ghost" borderRadius="md" onClick={onClickEdit}>
        <LuPencil />
      </IconButton>
      {onDelete != null && (
        <IconButton
          aria-label="Delete"
          size="2xs"
          variant="ghost"
          borderRadius="md"
          colorPalette="red"
          onClick={onClickDelete}
        >
          <LuTrash2 />
        </IconButton>
      )}
    </Flex>
  );
});
EditDeleteActions.displayName = 'EditDeleteActions';

export default EditDeleteActions;
